import { render } from "./important-dwdb-count.vue?vue&type=template&id=d160093c&scoped=true"
import script from "./important-dwdb-count.vue?vue&type=script&lang=js"
export * from "./important-dwdb-count.vue?vue&type=script&lang=js"

import "./important-dwdb-count.vue?vue&type=style&index=0&id=d160093c&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d160093c"]])

export default __exports__